import { IButtonStyles, Panel, PanelType, PrimaryButton, Stack } from "office-ui-fabric-react";
import { useContext } from "react";
import { Route, useHistory } from "react-router";
import { ProfileContext } from "../../Home";
import { IUserWithPhoto } from "../../types/User.types";
import { GlobalSettingsForm } from "./forms/GlobalSettingsForm";
import { UserManagementPanel } from "./menus/AdministratorsPanel";
import { ManageBookingsPanel } from "./menus/ManageBookings";
import { Reporting } from "./menus/Reporting";
import { SitesPanel } from "./menus/SitesPanel";
import { UpdateRoomDetails } from "./menus/UpdateRoomDetails";

export interface ISettingsPanelProps {
    profile?: IUserWithPhoto;
    onDismiss: () => void;
}

export const SettingsPanel = (props: ISettingsPanelProps) => {

    const userContext = useContext(ProfileContext);
    const history = useHistory();
    
    const buttonStyles: IButtonStyles = {
        root: { width: 250 },
        flexContainer: { justifyContent: "flex-start" },
        label: { textAlign: "left", paddingLeft: 5 }
    };

    const hasRoles = props.profile && props.profile.Roles;
    //@ts-ignore
    const isAdmin = hasRoles && props.profile.Roles.filter((r) => r.Name === "Admin").length > 0;
    //@ts-ignore
    const accessReporting = hasRoles && props.profile.Roles.filter((r) => r.Name === "Reporting" || r.Name === "Admin").length > 0;
    //@ts-ignore
    const accessBookingMgmt = hasRoles && props.profile.Roles.filter((r) => r.Name === "Booking Manager" || r.Name === "Admin").length > 0;
    const isRoomApprover = userContext?.Profile.RoomApprover

    return (
        <Panel 
            isOpen={true} 
            type={PanelType.smallFixedFar} 
            headerText="Settings" 
            onDismiss={props.onDismiss}
            onRenderFooter={() => <Stack styles={{root: { margin: 20 }}} horizontal horizontalAlign="end">v1.0.1</Stack>}
            styles={{
                scrollableContent: {
                    height: "100%",
                    overflow: "hidden"
                },
                content: {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    " .ms-Button": {
                        marginBottom: 20
                    }
                }
            }}
        >
            { isAdmin && (
                <>
                    <PrimaryButton styles={buttonStyles} iconProps={{iconName: "POISolid"}} text="Configure Sites" onClick={() => history.push("/menu/settings/sites")} />
                    <PrimaryButton styles={buttonStyles} iconProps={{iconName: "CRMServices"}} text="User Management" onClick={() => history.push("/menu/settings/usermanagement")} />
                </>
            )}
            { isRoomApprover && (
                <PrimaryButton styles={buttonStyles} iconProps={{iconName: "Room"}} text="Update Room Details" onClick={() => history.push("/menu/settings/updateroomdetails")} />
            )}
            { accessBookingMgmt && (
                <PrimaryButton styles={buttonStyles} iconProps={{iconName: "Calendar"}} text="Manage Desk Bookings" onClick={() => history.push("/menu/settings/manageBookings")} />
            )}
            { accessReporting && (
                <PrimaryButton styles={buttonStyles} iconProps={{iconName: "AnalyticsReport"}} text="Reporting" onClick={() => history.push("/menu/settings/reporting")} />
            )}
            { isAdmin && (
                <PrimaryButton styles={{...buttonStyles, root: {width: 250, marginTop: 40}}} iconProps={{iconName: "Settings"}} text="Global Settings" onClick={() => history.push("/menu/settings/global")} />
            )}
            { isAdmin && (
                <>
                    <Route path="/menu/settings/sites">
                        <SitesPanel onDismiss={() => history.goBack()} />
                    </Route>
                    <Route path="/menu/settings/usermanagement">
                        <UserManagementPanel onDismiss={() => history.goBack()} />
                    </Route>
                    <Route path="/menu/settings/global">
                        <GlobalSettingsForm onDismiss={() => history.goBack()} />
                    </Route>
                </>
            )}
            { accessBookingMgmt && (
                <Route path="/menu/settings/manageBookings">
                    <ManageBookingsPanel onDismiss={() => history.goBack()} />
                </Route>
            )}
            { accessReporting && (
                <Route path="/menu/settings/reporting">
                    <Reporting onDismiss={() => history.goBack()} />
                </Route>
            )}
            { isRoomApprover && (
                <Route path="/menu/settings/updateroomdetails">
                    <UpdateRoomDetails onDismiss={() => history.goBack()} />
                </Route>
            )}
        </Panel>
    );
}